import React from "react";
import {
  Box,
  Container,
  Grid,
  GridItem,
  Heading,
  Text,
  VStack,
  Image,
} from "@chakra-ui/react";
import collabrate from '../../../assets/carrer/collabrate.png'
import growth from '../../../assets/carrer/growth.png'
import inspiration from '../../../assets/carrer/inspiration.png'
import team from '../../../assets/carrer/team.png'

const benefits = [
  {
    icon: team,
    title: "Team work",
    description: "Thrive in an environment that champions innovation and collaboration.",
  },
  {
    icon: growth,
    title: "Empowerment & Growth",
    description: "Grow alongside a team that values your unique talents.",
  },
  {
    icon: inspiration,
    title: "Inspiration",
    description: "Work on projects that challenge and inspire.",
  },
  {
    icon: collabrate,
    title: "Collaborate & Thrive",
    description: "Join a team that celebrates your unique talents and fosters growth.",
  },
];

const Benefits = () => {
 

  return (
    <Box bg="#00475f" color="white" py={{ base: 10, md: 32 }}>
      <Container maxW="container.xl">
        <Grid
          templateColumns={{ base: "1fr", md: "1fr 1fr" }}
          gap={{ base: 10, md: 16 }}
          alignItems="center"
        >
          {/* Left Content */}
          <Box>
            <Heading
              as="h2"
              fontSize={{ base: "2xl", md: "3xl" }}
              mb={4}
              fontWeight="bold"
              className="fade-in-up"
            >
              Why Work With Us?
            </Heading>
            <Text fontSize={{ base: "md", md: "sm" }} color={'whiteAlpha.800'} fontWeight={"thin"} lineHeight="tall" className="fade-in-up">
              Are you a trailblazer with a spark of creativity? At Doggle India, a renowned web
              development company in Jaipur, we’re building a team that’s as vibrant and dynamic as
              our Rajasthani roots.
            </Text>
          </Box>

          {/* Right Content - Benefits Grid */}
          <Grid
            templateColumns={{ base: "1fr", sm: "1fr 1fr" }}
            gap={6}
          >
            {benefits.map((benefit, index) => (
              <GridItem key={index}>
                <VStack align="flex-start" spacing={4}>
                  {/* <Icon as={benefit.icon} boxSize={6} mt={1} color="white" className="fade-in-up" /> */}
                  <Image src={benefit.icon} boxSize={12}/>
                  <VStack align="start" spacing={1}>
                    <Text fontWeight="bold" fontSize="md" className="fade-in-up">
                      {benefit.title}
                    </Text>
                    <Text fontSize="sm" color="whiteAlpha.800" className="fade-in-up">
                      {benefit.description}
                    </Text>
                  </VStack>
                </VStack>
              </GridItem>
            ))}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Benefits;
